import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { deleteNewspapers } from '../../../../features/newspapers/newspaperSlice'


import { trash, check_mark } from '../../../../../assets'

import { RiDeleteBin5Line } from 'react-icons/ri'
import { FiEdit2 } from 'react-icons/fi'


const TableData = ({newspaper, setUpdateUIWithout, setCanEdit}) => {

   const dispatch = useDispatch()

   const onDelete = ()=> {
    setUpdateUIWithout(newspaper.newspaperId)
    dispatch(deleteNewspapers(newspaper.newspaperId))
    }

    const onEdit = ()=> {
        setCanEdit(newspaper.newspaperId)
        // dispatch(editResourceCategory(category.resourceCategoryId))
    }

//    console.log(tag)
  return (
    <Container>
        <div>
            <ul>
                <li>{newspaper?.newspaperName}</li>
                <li>{newspaper?.newspaperURL}</li>
                <li>{}</li>
                <li>{}</li>
                <li>
                    <ul>
                        <li> 
                            <RiDeleteBin5Line
                            size={'20px'} 
                            color= '#ff7f7f' 
                            onClick={ onDelete } /> 
                        </li>
                        <li> <FiEdit2 
                            size={'20px'} 
                            color= 'blue' onClick={ onEdit } /> </li>
                    </ul>
                </li>
            </ul>
        </div>
        
        
    </Container>
  )
}

const Container = styled.section`
    display: flex;
    width: 100%;
    margin-top: 2rem;

    & > div {
        width: inherit;
        &  ul {
        display: flex;
        justify-content: space-between;
        width: 100%;
        background-color: #ebeced;
        border-bottom: 1px solid;

        &  li {
            font-size: 12px;
            color: #667085;
            padding: 13px;
            flex: 1;

            & > ul {
                border-bottom: none;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                &  li {
                    padding: 0;
                    cursor: pointer;
                    width: max-content;
                    width: 50%;
                    margin-right: 0;

                    & > img {
                        /* width: max-content; */
                        width: 20px;
                    }
                }
            }
        }
    }

    }
    
`

export {TableData}